import { z } from 'zod';

const envSchema = z.object({
  VITE_API_BASE_URL: z.string().url(),
  VITE_APP_TITLE: z.string().min(1),
  VITE_DEFAULT_LANGUAGE: z.enum(['en', 'fr', 'ar']).default('en'),
});

type Env = z.infer<typeof envSchema>;

function validateEnv(): Env {
  const parsed = envSchema.safeParse({
    VITE_API_BASE_URL: import.meta.env['VITE_API_BASE_URL'],
    VITE_APP_TITLE: import.meta.env['VITE_APP_TITLE'],
    VITE_DEFAULT_LANGUAGE: import.meta.env['VITE_DEFAULT_LANGUAGE'],
  });

  if (!parsed.success) {
    console.error('Invalid environment variables:', parsed.error.flatten().fieldErrors);
    throw new Error('Invalid environment variables. Check .env file against .env.example');
  }

  return parsed.data;
}

export const env = validateEnv();
